import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchUsers {
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number>;
  pageSize?: number;
  search?: string;
}
export const useFetchUsers = (params: IUseFetchUsers) => {
  const fetchUsers = async ({ pageParam = 1 }) => {
    const { relations: activityStatusRelations, pageSize, extraFilters: filters, ...rest } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      queryString.append(`filter.${key}`, String(value));
    });

    (activityStatusRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    queryString.append('limit', String(pageSize));
    try {
      return await get(`${API_URLS.GET_USERS}?${queryString.toString()}`);
    } catch (error) {
      console.error('Error fetching users:', error);
      throw new Error((error as { message: string }).message || 'Failed to fetch users'); // Force error throwing
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['users-list', params],
    queryFn: fetchUsers,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
